import axios_ from "../utils/axios";
import { translateContent } from "./translateFetch";


export default {
  /**
   * 所有客服列表
   * @param {*} param
   * @returns
   */
  getCSlists(param) {
    return new Promise((resolve, reject) => {
      // getCSlists 和 getUsers 保持同一域名策略：测试走 cn.emkol.cn，生产走 cn.joinmc.cn。
      axios_("GET", `api/pandagpt/v1/cs/getCSlists`, param, false, false, true)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 客服列表
   * @param {*} param
   * @returns
   */
  getBotServices(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/cs/lists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 保存 编辑 客服
   * @param {*} param
   * @returns
   */
  storeBotService(param) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/cs/${param.id ? "update" : "insert"}`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 删除机器人
   * @param {*} param
   * @returns
   */
  delBotService(param) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/cs/del`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 客服详情
   * @param {*} param
   * @returns
   */
  botServiceDetail(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/cs/detail`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 是否启用自动回复
   * @param {*} param
   * @returns
   */
  switchBotStatus(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/updateReply`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取fb账户列表
   * @param {*} param
   * @returns
   */
  getFBAccounts(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/facebook/accountLists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取fb账户下的fb主页列表
   * @param {*} param
   * @returns
   */
  getFBPages(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/facebook/pageLists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取fb账户下的ins主页列表
   * @param {*} param
   * @returns
   */
  getInsPages(param) {
    return new Promise((resolve, reject) => {
      // axios_("GET", `api/pandagpt/v1/instagramData/account/list`, param, false, false, true)
      axios_("GET", `pyinterface/instagramData/data/instagram/account/list`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * fb授权登录回调接口
   * @param {*} param
   * @returns
   */
  FBLoginHandler(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/facebook/facebookLogin`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 人工客服-用户列表
   * @param {*} param
   * @returns
   */
  getFBChatUsers(param) {
    return new Promise((resolve, reject) => {
      // getUsers 需要走 cn.emkol.cn，对应 axios_ 的 Python/CN host 分支（VUE_APP_PY_CN_API_URL）。
      axios_("GET", `api/pandagpt/v1/fbChat/getUsers`, param, false, false, true)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * WhatsApp 客服会话列表由 Python 服务提供，筛选和分页参数以 POST body 提交。
   * @param {{display_type:number;page?:number;page_num?:number;page_id?:string;unread?:number;name?:string;tags?:string}} param
   * @param {{signal?:AbortSignal}} options 取消已过期的会话筛选请求
   * @returns {Promise<{code:number;data:object;msg:string}>}
   */
  getWhatsAppServiceUsers(param, { signal } = {}) {
    // 自带取消信号时跳过 axios 的同参数自动取消，由当前会话筛选独立管理请求生命周期。
    return axios_("POST", `api/pandagpt/v1/csAllocation/getUsers`, param, Boolean(signal), false, true, false, { signal });
  },
  /**
   * 将指定 WhatsApp 会话分配给客服；客服 ID 和会话联系人 ID 以 POST body 提交到 Python 服务。
   * @param {{customer_service:string;psid:string}} param
   * @returns {Promise<{code:number;data:object;msg:string}>}
   */
  manualAssignWhatsAppService(param) {
    return axios_("POST", `api/pandagpt/v1/csAllocation/manualAssign`, param, false, false, true);
  },
  /**
   * 结束指定 WhatsApp 联系人的人工客服服务；接口由 Python 服务提供。
   * @param {{psid:string}} param 会话联系人 ID
   * @returns {Promise<{code:number;data:object;msg:string}>}
   */
  manualEndWhatsAppService(param) {
    return axios_("POST", `api/pandagpt/v1/csAllocation/manualEndService`, param, false, false, true);
  },
  /**
   * 获取 WhatsApp 联系人的分页聊天记录；消息查询由 Python 服务提供。
   * @param {{psid:string|number;page_id?:string;issue_grade?:string;need_handle?:string;scene_id?:string;page?:number;page_num?:number}} param
   * @returns {Promise<{code:number;data:object;msg:string}>}
   */
  getWhatsAppMessages(param) {
    return axios_("GET", `api/pandagpt/v1/whatsApp/getMessages`, param, false, false, true);
  },
  /**
   * 更新客服联系人备注名。
   * 该接口由 Python 服务提供，和联系人列表保持同一 CN Host，空 nickname 表示清除备注。
   * @param {{cs_platform:number;id:string;nickname:string;page_id?:string}} param
   * @returns {Promise<{code:number;data:object;msg:string}>}
   */
  updateFBChatNickname(param) {
    return axios_("POST", `api/pandagpt/v1/fbChat/update_nickname`, param, false, false, true);
  },
  /**
   * 人工客服-用户-聊天记录
   * @param {*} param
   * @returns
   */
  getFBChatMessages(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbChat/getMessages`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 人工客服-用户-聊天记录-回复
   * @param {*} param
   * @returns
   */
  sendFBChatMessage(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbChat/sendMessage`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 人工客服-用户-聊天记录-回复-获取gpt答案
   * @param {*} param
   * @returns
   */
  getChatMessageGptAnswer(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbChat/gptFbReplyAdvice`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 人工客服-用户-聊天-设置聊天状态
   * @param {*} param
   * @returns
   */
  messageReadUnread(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbChat/readUnread`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 客服 设置 管理员
   * @param {*} param
   * @returns
   */
  csUpAdministrators(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/cs/upAdministrators`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * messenger 翻译（已切换到统一接口）
   * @param {string} text
   * @returns {Promise<{code:number;msg:string;data:string}>}
   */
  translateMessage(text) {
    return translateContent(text);
  },
  /**
   * messenger 设置待办
   * @param {*} param
   * @returns
   */
  setNeedHandle(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbChat/setNeedHandle`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取用户备注
   * @param {*} param
   * @returns
   */
  getUserRemarks(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbChat/getUserRemarks`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 写入用户备注
   * @param {*} param
   * @returns
   */
  setUserRemarks(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbChat/setUserRemarks`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取客服聊天数量
   * @param {*} param
   * @returns
   */
  getMessageNum(param) {
    return axios_("GET", `api/pandagpt/v1/fbChat/getMessageNum`, param);
  },
  /**
   * 新增/编辑插码数据
   * @param {*} param
   * @returns
   */
  storeDomainSite(param) {
    return axios_("POST", `api/pandagpt/v1/jscode/${param.page_id ? "uptStore" : "store"}`, param);
  },
  /**
   * 删除插码数据
   * @param {*} param
   * @returns
   */
  delDomainSite(param) {
    return axios_("POST", `api/pandagpt/v1/jscode/del`, param);
  },
  /**
   * 复制机器人
   * @param {*} param
   * @returns
   */
  fetchBotCopy(param) {
    return axios_("POST", `api/pandagpt/v1/csScene/copyinsertCs`, param);
  },
  /**
   * 数据分析列表
   * @param {*} param
   * @returns
   */
  getTeamBotStatistics(param) {
    return axios_("GET", `api/pandagpt/v1/StatisticsTeam/getSingleTeamCSStatistics`, param);
  },
  /**
   * 数据分析-折线
   * @param {*} param
   * @returns
   */
  getTeamBotLinesData(param) {
    return axios_("GET", `api/pandagpt/v1/StatisticsTeam/getSingleTeamCSDogleg`, param);
  },

  /**
   * 数据分析场景饼图
   * @param {{cs_type?:string;cs_id?:string;dateRange:string[]}} param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getTeamCSScenePieChart(param) {
    return axios_("GET", "api/pandagpt/v1/StatisticsTeam/getTeamCSScenePieChart", param);
  },

  /**
   * 数据分析场景列表
   * @param {{cs_type?:string;cs_id?:string;dateRange:string[]}} param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getTeamCSSceneLists(param) {
    return axios_("GET", "api/pandagpt/v1/StatisticsTeam/getTeamCSSceneLists", param);
  },
  /**
   * 机器人待办列表接口
   * @param {*} param
   * @returns
   */
  getBotsNeedHandles(param) {
    return axios_("GET", `api/pandagpt/v1/needHandleLists`, param);
  },

  /**
   * 机器人产品信息接口
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  botProductLists(param) {
    return axios_("GET", "api/pandagpt/v1/cs/csProductLists", param);
  },
  /**
   * 机器人产品信息接口
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  setProductRecommend(param) {
    return axios_("POST", "api/pandagpt/v1/cs/setCsProductRecommend", param);
  },
  /**
   * 机器人人工回复设置
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  setSceneManualReply(param) {
    return axios_("POST", "api/pandagpt/v1/bot/setSceneManualReply", param);
  },
};
